import { styled } from "baseui";

type TTriangleProps = {
  $color?: string;
  $size?: number;
};

const Triangle = styled<"div", TTriangleProps>(
  "div",
  ({ $theme, $color = "currentColor", $size = 24 }) => ({
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: `0 ${$size / 2}px ${$size}px ${$size / 2}px`,
    borderColor: `transparent transparent ${
      $theme.colors[$color] || $color
    } transparent`,
  })
);

export { Triangle };
